export enum TaskModalModeEnum {
  // Modal modes
  addNew,
  edit,
  viewOnly,
  partialViewOnly,
  assignableOnly
}
